/* eslint-disable max-statements */

export const validateNumber = (value) => {
  return isNaN(value) ?
    {value, 'error': {'content': 'SOLO SE ACEPTA VALORES NUMÉRICOS'}} :
    {value, 'error': false};
};

export const validateEmpty = (value) => {
  return !value ?
    {value, 'error': {'content': 'ESTE CAMPO ES OBLIGATORIO'}} :
    {value, 'error': false};
};

export const validateSQLBoolean = (value) => {
  return value !== 'S' ?
    {value, 'error': {'content': 'ESTE CAMPO ES OBLIGATORIO'}} :
    {value, 'error': false};
};

export const validateFloatingState = (value) => {
  return value === 'N' || value === 'D' ?
    {value, 'error': {'content': 'SELECCIONE UNA DE LAS OPCIONES'}} :
    {value, 'error': false};
};

export const validateId = (value) => {
  if (!value.length) {
    return {value, 'error': false};
  }

  const cad = value?.substring(0, 10);
  let total = 0;
  const longitud = cad.length;
  const longcheck = longitud - 1;
  if (cad !== '' && longitud === 10) {
    for (let i = 0; i < longcheck; i++) {
      if (i % 2 === 0) {
        let aux = cad.charAt(i) * 2;
        if (aux > 9) {
          aux -= 9;
        }
        total += aux;
      } else {
        total += parseInt(cad.charAt(i), 10);
      }
    }
    total = total % 10 ? 10 - (total % 10) : 0;
    if (cad.charAt(longitud - 1) === `${total}`) {
      return {value, 'error': false};
    }
  }
  return {value, 'error': {'content': 'CÉDULA INVÁLIDA'}};
};

export const validateUpperCase = (value = '') => {
  const valueUpper = value?.toLocaleUpperCase() || '';
  return {'value': valueUpper, 'error': false};
};

export const validateTextUpperCase = (value = '') => {
  const valueUpper = value?.toLocaleUpperCase() || '';
  const regMayusNoSpecial = /^$|^[A-ZÑ ]+$/g;
  const regMayusNoSpecialRemove = /^$|[^A-ZÑ ]+$/g;
  const testUpper = regMayusNoSpecial.test(valueUpper);
  const removedElement = valueUpper.replace(regMayusNoSpecialRemove, '');
  return testUpper ?
    {'value': removedElement, 'error': false} :
    {
      'value': removedElement,
      'error': {'content': 'NO SE ACEPTAN CARACTERES ESPECIALES'},
    };
};

export const validateTextNoAccent = (value = '') => {
  const valueUpper = value?.toLocaleUpperCase() || '';
  const regMayusNoSpecial = /^$|^[^áÁéÉíÍóÓúÚ]+$/g;
  const testUpper = regMayusNoSpecial.test(valueUpper);
  return testUpper ?
    {'value': valueUpper, 'error': false} :
    {
      'value': valueUpper,
      'error': {'content': 'NO SE ACEPTAN CARACTERES ESPECIALES'},
    };
};

export const validateUpperCaseAndSpecial = (value = '') => {
  const valueUpper = value?.toLocaleUpperCase() || '';
  const regMayusNoSpecial = /^$|^[A-Z.,:;-\d\r\n&Ñ_ ]+$/g;
  const regMayusNoSpecialRemove = /^$|[^A-Z.,:;-\d\r\n&Ñ_ ]+$/g;
  const testUpper = regMayusNoSpecial.test(valueUpper);
  const removedElement = valueUpper.replace(regMayusNoSpecialRemove, '');
  return testUpper ?
    {'value': removedElement, 'error': false} :
    {
      'value': removedElement,
      'error': {'content': 'NO SE ACEPTAN CARACTERES ESPECIALES'},
    };
};

export const validateEmailCase = (value) => {
  if (!value) {
    return {'value': value, 'error': false};
  }
  const regEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  const testUpper = regEmail.test(value);
  return testUpper ?
    {'value': value, 'error': false} :
    {
      'value': value,
      'error': {'content': 'EMAIL NO VÁLIDO'},
    };
};

export const validateLengthId = (value) => {
  const returnValue = value;
  if (value?.length > 10) {
    return {
      'value': returnValue,
      'error': {'content': 'EL NÚMERO DE CARACTERES NO ES CORRECTO'},
    };
  }
  return {value, 'error': false};
};

export const validateRucLength = (value) => {
  const returnValue = value;
  if (value?.length !== 13) {
    return {
      'value': returnValue,
      'error': {'content': 'EL NÚMERO DE CARACTERES NO ES CORRECTO'},
    };
  }
  return {value, 'error': false};
};

export const validateIsRUCSelection = (value) => {
  if (value !== 'R') {
    return {
      'value': value,
      'error': {'content': 'SOLO SE DEBE INGRESAR UN RUC'},
    };
  }
  return {value, 'error': false};
};

export const validateDiscPercentajes = (value, extraData = {}) => {
  const {minValue} = extraData;
  if (parseInt(value, 10) < minValue || parseInt(value, 10) > 100) {
    return {
      'value': value,
      'error': {'content': `INGRESE UN VALOR ENTRE ${minValue} Y 100`},
    };
  }
  return {value, 'error': false};
};
